import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="flex flex-col space-y-3">
            <h3 className="text-lg font-semibold mb-2">Contato Direto</h3>
            <a
              href="https://wa.me/5534996687855"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-indigo-400 transition-colors"
            >
              <Phone className="h-5 w-5" />
              <span>+55 34 99668-7855</span>
            </a>
            <a
              href="mailto:suporte@aiaura.com.br"
              className="flex items-center space-x-2 hover:text-indigo-400 transition-colors"
            >
              <Mail className="h-5 w-5" />
              <span>suporte@aiaura.com.br</span>
            </a>
            <a
              href="https://www.instagram.com/aiauramkt/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-indigo-400 transition-colors"
            >
              <Instagram className="h-5 w-5" />
              <span>@aiauramkt</span>
            </a>
          </div>
          
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-4">Suporte</h3>
            <a
              href="https://wa.me/5534996687855"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 hover:text-indigo-400 transition-colors"
            >
              <MessageCircle className="h-5 w-5" />
              <span>Dúvidas? Clique aqui</span>
            </a>
          </div>

          <div className="text-center md:text-right">
            <Link
              to={`https://wa.me/5534996687855?text=Olá, tenho interesse em contratar um gestor por $397!`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors text-center"
            >
              Contrate um Gestor de Tráfego à Partir de $397
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;